import { userService } from "../services";
import config from "../config/config";

export const UserAction = {
  updateSubUserById,
  findSubUserById,
  addSubUser,
  fetchAllSubUsers,
  fetchAllSubUsersVehicles,
  fetchUserList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  AddLogo,
  fetchAllSubUsersForDropdown,
  updateProfilePicture,
};

async function fetchUserList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.UserList
    }?companyId=${payload.companyId}&pageSize=${payload.pageSize}&pageNo=${
      payload.pageNo
    }&employeeCode=${payload.employeeCode}&siteId=${payload.siteId}&name=${
      payload.name
    }`;
    // &pageSize=${payload.pageSize}&pageNo=${payload.pageNo}
    //debugger
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.UpdateUser
    }`;
    let data = new FormData();
    data.append("name", payload.name);
    data.append("gender", payload.gender);
    data.append("id", payload.id);
    data.append("phoneNumber", payload.phoneNumber);
    data.append("designation", payload.designation);
    data.append("address", payload.address);
    data.append("updatedBy", payload.updatedBy);
    data.append("company", payload.company);
    data.append("file", payload.file);
    data.append("isActive", payload.isActive);

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.AddUser
    }`;
    let data = new FormData();

    data.append("name", payload.name);
    data.append("employeeCode", payload.employeeCode);
    data.append("gender", payload.gender);
    data.append("email", payload.email);
    data.append("phoneNumber", payload.phoneNumber);
    data.append("designation", payload.designation);
    data.append("address", payload.address);
    data.append("createdBy", payload.createdBy);
    data.append("company", payload.company);
    data.append("file", payload.file);

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.ActiveUser
    }`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.GetUserById
    }?id=${payload.userId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

// sub users common call
async function fetchAllSubUsers(payload) {
  debugger;
  try {
    // const name = JSON.parse(localStorage.getItem("data")).name;
    const companyId = JSON.parse(localStorage.getItem("data")).companyId;
    const apiEndpont = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SubUsersList
    }?userType=${payload?.data?.name ? payload.data.name:""}&companyId=${companyId}&pageNo=${
      payload.pageNo ? payload.pageNo : 0
    }&pageSize=${payload.pageSize ? payload.pageSize : 0}&email=${
      payload.email ? payload.email : ""
    }&name=${payload.name ? payload.name : ""}&forDropDown=${
      payload.forDropDown ? payload.forDropDown : null
    }`;

    // const apiEndpont = `http://192.168.12.24:8082/${config.apiName.SubUsersList}?userType=${payload.name}&companyId=${companyId}`;

    const response = await userService.get(apiEndpont);
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchAllSubUsersForDropdown(payload) {
  debugger;
  try {
    // const name = JSON.parse(localStorage.getItem("data")).name;
    const companyId = JSON.parse(localStorage.getItem("data")).companyId;
    const apiEndpont = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SubUsersListLite
    }?userType=${payload?.data?.name ? payload.data.name:""}&companyId=${companyId}&pageNo=${
      payload.pageNo ? payload.pageNo : 0
    }&pageSize=${payload.pageSize ? payload.pageSize : 0}&email=${
      payload.email ? payload.email : ""
    }&name=${payload.name ? payload.name : ""}&forDropDown=${
      payload.forDropDown ? payload.forDropDown : null
    }`;

    // const apiEndpont = `http://192.168.12.24:8082/${config.apiName.SubUsersList}?userType=${payload.name}&companyId=${companyId}`;

    const response = await userService.get(apiEndpont);
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function fetchAllSubUsersVehicles(payload) {
  
  try {
    const apiEndpont = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SubUsersVehicleList
    }`;

    const response = await userService.post(apiEndpont, {
      userTypeId: payload.userTypeId,
      notifyEmailId: payload.notifyEmailId,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function addSubUser(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.AddSubUser
    }`;

    // const apiEndpoint = `http://192.168.12.24:8082/${config.apiName.AddSubUser}`;

    const response = await userService.post(apiEndpoint, payload);
    if (response && (response.status === 201 || response.status === 208)) {
      return response;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function findSubUserById(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SubUserById
    }?id=${payload.id}`;

    // const apiEndpoint = `http://192.168.12.24:8082/${config.apiName.SubUserById}?id=${payload.id}`;

    const response = await userService.get(apiEndpoint);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function updateSubUserById(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.UpdateSubUser
    }`;

    // const apiEndpoint = `http://192.168.12.24:8082/${config.apiName.UpdateSubUser}`;

    const response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function AddLogo(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.LogoUrl
    }`;

    const response = await userService.post(apiEndpoint, payload);
    if (response.status === 200) {
      return response.data;
    } else {
      alert(response.data.message);
      return null;
    }
  } catch (err) {
    alert(err);
    console.log(err);
    return null;
  }
}

async function updateProfilePicture(payload) {
  try {
    const baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl;
    const apiEndpoint = `${baseUrl}${config.apiName.updateProfilePicture}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    } else {
      console.log("updateProfilePicture failed:", response);
      return null;
    }
  } catch (error) {
    console.log("updateProfilePicture error:", error);
    return null;
  }
}

